// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3c87f","clinicsSelect":"styles_clinicsSelect__2CGs1"};